<template>
  <div id="content"
       class="container">
    <header>
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('bookList')">证书查询</div>
      </div>
    </header>
    <div class="certificate-con">
      <!-- 查询条件 -->
      <div class="search">
        <el-form ref="dataForm"
                 :model="dataForm"
                 :inline="true">
          <el-form-item label="姓名"
                        prop="name">
            <el-input size="medium"
                      v-model="dataForm.name"
                      placeholder="请输入姓名"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="电话号码"
                        prop="phone">
            <el-input size="medium"
                      v-model="dataForm.phone"
                      placeholder="请输入电话号码"
                      clearable></el-input>
          </el-form-item>
          <el-button style="width:130px;height:34px;background:#fff;border:1px solid #1D65A8;color:#1D65A8"
                     @click="getDataList()">查询</el-button>
        </el-form>
      </div>
      <!-- 证书列表 -->
      <div class="search-list">
        <ul class="search-list-con" v-show="!showNoData">
          <li v-for="data in dataList"
              :key="data.id">
            <div class="list-img">
              <img :src="data.imgUrl?data.imgUrl:imgUrl" />
            </div>
            <div class="list-con">
              <h3>{{data.cerName}}</h3>
              <p style="margin:15px 0">姓名：<span>{{data.username}}</span></p>
              <p>电话号码：<span>{{data.mobile}}</span></p>
              <p style="margin:15px 0">证书编号：<span>{{data.cerCode}}</span></p>
              <p>证书名称：<span>{{data.cerName}}</span></p>
              <p style="margin:15px 0">获得证书时间：<span>{{data.awardTime}}</span></p>
            </div>
            <div class="list-btn">
              <el-button style="width:130px;height:34px;background:#fff;border:1px solid #1D65A8;color:#1D65A8"
                         @click="handleBuy(data.id)">补办纸质证书</el-button>
            </div>
          </li>
        </ul>
        <!-- 没有证书时提示 -->
        <div class="no_show_message" slot="empty" v-show="showNoData">
          <img src="@/assets/img/good/noGood.png" alt="暂无相关订单">
          <div>抱歉，没找到证书</div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="doclist-pagination"
         v-if="dataList === [] || dataList.length !== 0">
      <div class="doclist-lastpage"
           @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''"
            v-for="(item, index) in pageList"
            :key="index"
            @click="getDataList(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage"
           @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{totalPage}}页，到第
        <input type="text"
               v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump"
           @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataForm: {
        name: '',
        phone: ''
      },
      pageIndex: 1,
      pageSize: 10,
      totalData: 0,
      dataList: [],
      imgUrl: '../../../../assets/img/占位图_en.png',
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      showNoData: false // 抱歉没找到证书
    }
  },
  mounted () {
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'bookList') {
        this.$router.push({ name: 'bookList' })
      }
    },
    // 获取证书
    getDataList (page = this.currentPage) {
      if (!this.$store.state.user.id) {
        this.$router.push({ name: 'login' })
        return
      }
      this.showNoData = false
      this.$http.post(`/front/train/trainCertificateUser/listAtFrontGround`, {
        'page': page,
        'limit': this.pageSize,
        'name': this.dataForm.name,
        'mobile': this.dataForm.phone
      }).then(({ data: res }) => {
        if (res.code !== -1) {
          this.dataList = res.data.data || []
          this.totalData = res.data.count
          if (!this.dataList.length) {
            this.showNoData = true
          } else {
            this.showNoData = false
          }
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(page)
        }
      })
      this.jumpTargetPage = 1
    },
    // 补办证书-立即购买
    // 立即购买
    handleBuy (id) {
      if (getAccessToken()) {
        // 验证是否是本人
        this.$http.get(`/front/train/trainCertificateUser/checkPaperCertificate`, {
          params: {
            'id': id
          }
        }).then(({ data: res }) => {
          if (res.code === 0) {
            //  跳转页面
            this.$router.push({ name: 'settlement', query: { goodsId: id, type: 5 } })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
      }
    },
    // 分页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
.certificate-con {
  width: 100%;
  min-height: 400px;
  background: #fff;
}
.search {
  padding: 20px 30px;
  height: 60px;
  text-align: center;
}
.search-list {
  min-height: 400px;
  padding: 20px 20px;
  .no_show_message{
    text-align: center;
  }
}
.search-list-con {
  margin: 0 auto;
  min-height: 400px;
}
.search-list-con li {
  width: 100%;
  height: 270px;
  padding: 20px 70px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.list-img {
  width: 300px;
  height: 230px;
  float: left;
  padding: 10px;
}
.list-img img {
  width: 100%;
  height: 100%;
}
.list-con {
  width: 500px;
  height: 210px;
  float: left;
  padding: 10px;
  color: #333;
}
.list-btn {
  width: 200px;
  height: 210px;
  float: left;
  padding-top: 170px;
}
.list-con h3 {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
</style>
